import apiClient from './apiClient';

/**
 * Per-hotel outbound email (SMTP) configuration.
 *
 * Whatever is saved here drives EVERY outbound email for the property —
 * confirmations, cancellations, invoices, reminders, staff notifications and
 * newsletters. The password is write-only: the GET never returns it, and
 * sending MASKED_PASSWORD (or omitting the field) leaves the stored one alone.
 */
export const MASKED_PASSWORD = '••••••••';

const emailSettingsService = {
  get: () => apiClient.get('/v1/settings/email'),
  update: (data) => apiClient.put('/v1/settings/email', data),
  // `data` may carry unsaved credentials so the hotel can verify a mail server
  // BEFORE overwriting a working configuration with a broken one.
  test: (data) => apiClient.post('/v1/settings/email/test', data || {}),
};

export default emailSettingsService;
